module.exports = __webpack_public_path__ + "media/images/undraw_checkmark_shield-680d7eb870b09616d791b5377eb7084f.png";